import React from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import ExploreResultLocations from "../component/ExploreResultLocations";
import FAQ from "../component/FAQ";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import { Container } from "react-bootstrap";
import RealEstateAgents from "../component/RealEstateAgents";
function FindAgent() {
  return (
    <>
      <div className="main find-agent-page">
        <Header />
        <CommonBanner title="Find an agent" />
        <RealEstateAgents />
        <ConnectAgentCTA />
        <FAQ />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}
export default FindAgent;
